import { BUCKET_BY_TYPES, EXPERIMENT_PROJECTS } from '@lusha/experiment-react-sdk';
const FLAGS = {
    // PLUGIN_BULK_FILTERS_TEST: {
    //   key: 'plugin_bulk_filters_test',
    //   project: EXPERIMENT_PROJECTS.PLUGIN,
    //   bucketBy: BUCKET_BY_TYPES.ACCOUNT_ID,
    //   variations: {
    //     CONTROL: 'control_filters',
    //     TEST: 'test_bulk_dropdown_filters',
    //   },
    // },
    PLUGIN_UPGRADE_MODAL: {
        enabled: true,
        preload: { enrolledOnly: true },
        project: EXPERIMENT_PROJECTS.PLUGIN,
        bucketBy: BUCKET_BY_TYPES.ACCOUNT_ID,
        key: 'plugin_free_upgrade_popup_premium_default',
        variations: {
            TEST: 'test_starter_pro_premium_cards_premium_preselected_annual',
            CONTROL: 'control_popup_no_plan_cards_link_out_to_purchase',
        },
    },
    PLUGIN_PIPELINE_TAB: {
        enabled: true,
        project: EXPERIMENT_PROJECTS.PLUGIN,
        bucketBy: BUCKET_BY_TYPES.ACCOUNT_ID,
        key: 'plugin_pipeline_tab_early_beta_enrollment',
        variations: {
            TEST: 'test_pipeline_tab_shown',
            CONTROL: 'control_activity_tab_shown',
        },
    },
    PLUGIN_WATERFALL_BANNER: {
        enabled: true,
        project: EXPERIMENT_PROJECTS.PLUGIN,
        bucketBy: BUCKET_BY_TYPES.ACCOUNT_ID,
        key: 'plugin_waterfall_banner_early_beta_enrollment',
        variations: {
            TEST: 'test_waterfall_banner_shown',
            CONTROL: 'control_no_waterfall_banner_shown',
        },
    },
    PLUGIN_HEADER_UPGRADE_CTA_LABEL: {
        enabled: true,
        project: EXPERIMENT_PROJECTS.PLUGIN,
        bucketBy: BUCKET_BY_TYPES.ACCOUNT_ID,
        key: 'plugin_header_upgrade_cta_label',
        variations: {
            TEST: 'test_upgrade_label',
            CONTROL: 'control_go_pro_label',
        },
    },
};
const FLAG_SETTINGS = [
    // {
    //   key: FLAGS.PLUGIN_BULK_FILTERS_TEST.key,
    //   project: EXPERIMENT_PROJECTS.PLUGIN,
    //   preload: { disableImpression: true },
    //   enabled: true,
    //   bucketBy: BUCKET_BY_TYPES.ACCOUNT_ID,
    //  },
    {
        key: FLAGS.PLUGIN_UPGRADE_MODAL.key,
        project: EXPERIMENT_PROJECTS.PLUGIN,
        bucketBy: BUCKET_BY_TYPES.ACCOUNT_ID,
        preload: false,
    },
    {
        key: FLAGS.PLUGIN_WATERFALL_BANNER.key,
        project: EXPERIMENT_PROJECTS.PLUGIN,
        bucketBy: BUCKET_BY_TYPES.ACCOUNT_ID,
        preload: false,
    },
    {
        key: FLAGS.PLUGIN_PIPELINE_TAB.key,
        project: EXPERIMENT_PROJECTS.PLUGIN,
        bucketBy: BUCKET_BY_TYPES.ACCOUNT_ID,
        preload: false,
    },
    {
        key: FLAGS.PLUGIN_HEADER_UPGRADE_CTA_LABEL.key,
        project: EXPERIMENT_PROJECTS.PLUGIN,
        bucketBy: BUCKET_BY_TYPES.ACCOUNT_ID,
        preload: false,
    },
];
export { FLAG_SETTINGS, FLAGS };
